import { get } from 'lodash';
import { AuthContextProps } from 'react-oidc-context';

export const checkIfInvalidGrantError = (auth: AuthContextProps) => {
  return get(auth, 'error.error', get(auth, 'error.innerError.error', null)) === 'invalid_grant';
};
